import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate, useParams } from 'react-router-dom';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
  useGetSingleChildRestaurantQuery,
} from '@durma-soft/gros-sdk';

import { Modal } from '@/components/shared/modal';
import { Alert } from '@/components/shared/alert';
import { ModalFormSkeleton } from '@/components/shared/modal-form-skeleton';
import { EditRestaurantPartnerForm } from '@/components/restaurant/partners/edit-restaurant-partner-form';

export const EditRestaurantPartnerModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { partnerId } = useParams();

  if (!partnerId) {
    throw new Error('Partner ID is required for editing menu type');
  }

  const restaurant = useAuthUserRestaurant();
  const hasEditPermission = restaurant.role !== RESTAURANT_USER_ROLE.EMPLOYEE;

  const {
    data: partnerRestaurant,
    isSuccess,
    isError,
    isLoading,
  } = useGetSingleChildRestaurantQuery({
    child_restaurant_id: Number(partnerId),
    restaurant_id: restaurant.id,
  });

  const closeModal = () => navigate('/restaurant/partners', { replace: true });

  const isModalOpen = Boolean(
    useMatch({ path: '/restaurant/partners/edit/:partnerId' }),
  );

  return (
    <Modal
      key={partnerId}
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('partner.edit')}
      description={t('partner.edit-details')}
      className="flex flex-col overflow-y-hidden"
    >
      {isLoading && <ModalFormSkeleton />}
      {!hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.edit-not-allowed')}
          description={t('common.edit-not-allowed-description')}
        />
      )}
      {isError && hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.error')}
          description={t('common.try-later')}
        />
      )}
      {isSuccess && hasEditPermission && (
        <EditRestaurantPartnerForm
          partnerRestaurant={partnerRestaurant}
          onClose={closeModal}
        />
      )}
    </Modal>
  );
};
